import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { 
  HybridSearchRequest,
  HybridSearchResponse,
  HybridSearchResult
} from '../models/mrsearch.models';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MRSearchService {
  private readonly SEARCH_ENDPOINT = `${environment.apiBaseURL}/api/search`;

  constructor(private http: HttpClient) {}

  /**
   * Perform hybrid vector search via backend API
   * @param request - The hybrid search request object
   * @returns Observable with hybrid search results
   */
  public hybridSearch(request: HybridSearchRequest): Observable<HybridSearchResponse> {
    return this.http.post<any>(this.SEARCH_ENDPOINT, request).pipe(
      map(data => {
        const results: HybridSearchResult[] = (data.value || []).map((item: any) => ({
          score: item['@search.score'] || 0,
          document_title: item.document_title || '',
          website_url: item.website_url || '',
          section_label: item.section_label || '',
          section_title: item.section_title || '',
          body: item.body || '',
          modalityAcronym: item.modalityAcronym || '',
          productId: item.productId || '',
          productTitle: item.productTitle || '',
          infoclassname: item.infoclassname || ''
        }));
        return {
          success: true,
          results: results,
          total_count: typeof data['@odata.count'] === 'number' ? data['@odata.count'] : results.length
        } as HybridSearchResponse;
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Hybrid search failed:', error);
        return throwError(() => new Error(`Search API error! status: ${error.status}, message: ${error.message}`));
      })
    );
  }

  /**
   * Build filter expression for modality and product filtering
   * @param modality - The modality to filter by (e.g. 'MR', 'CT', 'XR', 'All')
   * @param productTitle - The product title to filter by
   * @returns OData filter expression or null
   */
  public buildProductFilter(modality: string, productTitle: string): string | null {
    // If both are 'All', no filter needed
    if ((!modality || modality === 'All') && (!productTitle || productTitle === 'All')) {
      return null;
    }
    
    if (modality && modality !== 'All') {
      const escapedModality = modality.replace(/'/g, "''");
      return `modalityAcronym eq '${escapedModality}'`;
    }

    return null;
  }
}
